module.exports = __webpack_public_path__ + "img/findmyweather.7a8cd08f.jpg";